import { render, staticRenderFns } from "./DialogCreateQuickResponse.vue?vue&type=template&id=712f71f3&scoped=true&"
import script from "./DialogCreateQuickResponse.vue?vue&type=script&lang=js&"
export * from "./DialogCreateQuickResponse.vue?vue&type=script&lang=js&"
import style0 from "./DialogCreateQuickResponse.vue?vue&type=style&index=0&id=712f71f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712f71f3",
  null
  
)

export default component.exports